var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.933 16.933",
    id: "JpgFile",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.968,
    transform: "matrix(1.03366 0 0 1.03333 -2.911 3.935)",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M 4.9217235,-3.8085938 A 0.25603411,0.25603411 0 0 0 4.6658641,-3.5527344 V 12.322266 a 0.25603411,0.25603411 0 0 0 0.2558594,0.255859 H 17.093598 a 0.25603411,0.25603411 0 0 0 0.255859,-0.255859 V 1.3886719 a 0.25603411,0.25603411 0 0 0 -0.07227,-0.1796875 l -4.796875,-4.9179688 v -0.00195 a 0.25600851,0.25600851 0 0 0 -0.01953,-0.019531 0.25600851,0.25600851 0 0 0 -0.02149,-0.019531 0.25600851,0.25600851 0 0 0 -0.02344,-0.017578 0.25600851,0.25600851 0 0 0 -0.02344,-0.013672 0.25600851,0.25600851 0 0 0 -0.01367,-0.00586 0.25600851,0.25600851 0 0 0 -0.02539,-0.00977 0.25600851,0.25600851 0 0 0 -0.01367,-0.00391 0.25600851,0.25600851 0 0 0 -0.0059,0 0.25600851,0.25600851 0 0 0 -0.03711,-0.00586 0.25600851,0.25600851 0 0 0 -0.01367,-0.00195 0.25600851,0.25600851 0 0 0 -0.0059,0 h -0.0078 z m 0.2558594,0.5117188 h 6.9902341 l 4.669922,4.7890625 V 12.066406 H 5.1775829 Z",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: 1
    },
    d: "M 12.269531 -3.8085938 A 0.25603411 0.25603411 0 0 0 12.021484 -3.5527344 L 12.021484 1.3886719 A 0.25603411 0.25603411 0 0 0 12.277344 1.6445312 L 17.09375 1.6445312 A 0.25603411 0.25603411 0 0 0 17.277344 1.2089844 L 12.460938 -3.7304688 A 0.25603411 0.25603411 0 0 0 12.269531 -3.8085938 z M 12.533203 -2.921875 L 16.488281 1.1328125 L 12.533203 1.1328125 L 12.533203 -2.921875 z ",
    color: "#000",
    enableBackground: "accumulate",
    fontFamily: "sans-serif",
    fontWeight: 400,
    opacity: 0.99,
    overflow: "visible",
    fill: "#437ef7",
    className: "color000000 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      lineHeight: 2,
      InkscapeFontSpecification: "Calibri",
      textAlign: "center"
    },
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.265,
    "aria-label": "JPG",
    fontFamily: "Calibri",
    fontSize: 5.292,
    opacity: 0.99,
    textAnchor: "middle",
    className: "colorStroke000000 svgStroke"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#437ef7",
    stroke: "none",
    d: "M6.0184946 14.322123q0 .198955-.036174.364319-.036174.165365-.1240235.281637-.08785.116272-.2325441.180868-.1421103.06201-.3539838.06201-.072347 0-.1446941-.01292-.069763-.01033-.1291911-.03101-.059428-.01809-.103353-.03876-.043925-.02325-.059428-.03876-.012919-.0155-.023254-.03101-.00775-.0155-.015503-.03617-.00517-.02325-.00775-.05426-.00258-.03359-.00258-.0801 0-.05684.00258-.09302.00517-.03876.015503-.05943.010335-.02325.023254-.03101.015503-.01034.036174-.01034.02067 0 .051676.02067.03359.01809.077515.04134.046509.02325.1059368.04392.059428.01809.1395264.01809.08785 0 .1498618-.02067.062012-.02325.1033529-.08268.041341-.05943.062012-.16278.020671-.105937.020671-.273886v-2.39262q0-.01809.010335-.03359.010335-.0155.036173-.02584.025838-.01033.067179-.0155.043925-.0052.1085206-.0052.062012 0 .1059368.0052.043925.0052.067179.0155.025838.01033.036174.02584.012919.0155.012919.03359zM8.9511339 12.800251q0 .250631-.082682.45217-.082682.201538-.2377117.343648-.1524455.14211-.3772382.219625-.2222088.07752-.5322675.07752h-.379822v1.204061q0 .02067-.012919.03617-.010335.0155-.036173.02584-.023254.0078-.067179.01292-.041341.0078-.1059367.0078-.064596 0-.1085206-.0078-.041341-.0052-.067179-.01292-.025838-.01033-.036173-.02584-.010335-.0155-.010335-.03617v-3.085085q0-.103352.05426-.147277.05426-.04392.1214396-.04392h.7157191q.1085205 0 .2067058.01033.1007691.0078.2351279.03876.1369427.02842.2764691.111105.1421103.0801.2402956.198954.098185.118856.1498617.276469.05426.155029.05426.343648zm-.467672.03617q0-.204122-.077515-.341065Q8.3310163 12.358418 8.2173281 12.291238 8.1062237 12.224059 7.984784 12.205972 7.8659282 12.187885 7.7522399 12.187885H7.3414121v1.341005h.4004925q.2015383 0 .3333132-.05168.1343588-.05168.2247927-.14211.090434-.09302.1369426-.219625.046509-.129191.046509-.279053zM12.147323 12.275735q0 .04909-.0052.08785-.0052.03617-.0155.06201-.01034.02326-.02584.03359-.0155.01033-.03359.01033-.03101 0-.103353-.04909-.07235-.04909-.193787-.10852-.12144-.05943-.291972-.108521-.167948-.04909-.400493-.04909-.276469 0-.496094.100769-.219625.100769-.37207.279053-.152446.178284-.2351281.423747-.080099.245463-.080099.532267 0 .320394.08785.568441.090434.248047.2480466.41858.157614.170532.374655.258382.219625.08785.480591.08785.155029 0 .312642-.03617.160198-.03876.29714-.113689v-.974101h-.775147q-.04392 0-.06718-.04392-.02067-.04392-.02067-.136943 0-.04909.0052-.08268.0052-.03617.0155-.05684.01292-.02326.02842-.03359.0155-.01033.03876-.01033h1.061952q.02842 0 .05684.01033.02842.01033.05168.03101.02325.02067.03617.05684.01292.03617.01292.08268v1.273824q0 .06718-.02325.116272-.02325.04909-.09819.08785-.07493.03617-.193787.0801-.118856.04392-.245463.07493-.126607.03101-.255798.04651-.129192.0155-.255799.0155-.387573 0-.692464-.118856-.304892-.12144-.5167651-.343649-.2092897-.222209-.3203941-.532267-.1111044-.310059-.1111044-.692465 0-.397909.1188559-.720887.1214397-.322978.3384808-.550354.2196249-.227376.5245159-.3514.307475-.126607.679546-.126607.191203 0 .359151.03359.167949.03359.29714.0801.131775.04392.219625.09819.09043.05168.124023.08527.03359.03359.04651.07752.01292.04393.01292.126607z",
    fontWeight: 400,
    className: "color000000 svgShape"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.5ad35989f657e89f67f0f04a13b1b595.svg";
export { ForwardRef as ReactComponent };